<template>
  <BreadCrumb PageTitle="Navs & Tabs" />
  <NavsTabs />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import NavsTabs from "../../template-components/UIElements/NavsTabs/NavsTabs.vue";

export default defineComponent({
  name: "NavsTabsPage",
  components: {
    BreadCrumb,
    NavsTabs,
  },
});
</script>